import React, { Component } from "react";
import { Typography, Tooltip } from "material-ui-next";
import { SaleStatus } from "core/enum";
import { If } from "components/support";

class SaleStatusSemaphore extends Component {
  formatStatusColor(status, description, code, type) {
    const colors = {
      error: "#ff8888",
      active: "#96e8a1",
      cancelled: "#ccc",
      cancelled_order: "#ccc"
    };

    const tooltipStyle = {
      fontSize: "1.5em",
      color: "white"
    };

    const spanStatus = (
      <span style={{ cursor: "pointer" }}>
        <span
          style={{
            background: colors[status],
            display: "inline-block",
            marginRight: 5,
            borderRadius: 10,
            width: 10,
            height: 10
          }}
        />
        {SaleStatus[status]}
      </span>
    );

    if (code || type === "cfe") {
      return (
        <Tooltip
          title={
            <Typography style={tooltipStyle}>
              <If test={code}>
                {code}: {description}
              </If>
              <If test={type === "cfe"}>Emitida pelo SAT</If>
            </Typography>
          }
        >
          {spanStatus}
        </Tooltip>
      );
    } else {
      return spanStatus;
    }
  }

  render() {
    const { status, description, code, type } = this.props;
    return this.formatStatusColor(status, description, code, type);
  }
}

export default SaleStatusSemaphore;



// WEBPACK FOOTER //
// ./src/components/support/sale-status-semaphore/index.jsx